import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

/**
 * Icon for BoxStaffHeadCoach, it's a cap with a star
 * @param props
 * @returns
 */
export const BoxStaffHeadCoachIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_12328_76611"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="13"
      y="10"
      width="31"
      height="23"
    >
      <path
        d="M14.1472 17.8557C12.777 21.1553 13.2826 28.0353 13.2826 28.0353C13.2826 28.0353 16.8859 30.3356 19.4676 31.1279C24.9621 32.8141 28.6752 31.9525 34.1571 30.2259C38.1072 28.9818 43.5636 25.3294 43.5636 25.3294V22.7522H41.8885C41.8885 22.7522 42.0015 20.2279 41.4653 18.3924C40.768 16.0048 39.965 14.3661 38.0228 12.8303C36.8608 11.9114 29.1954 10.0233 23.8487 11.5418C19.0145 12.9147 15.2957 15.0901 14.1472 17.8557Z"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask0_12328_76611)">
      <path
        d="M14.1472 17.8557C12.777 21.1553 13.2826 28.0353 13.2826 28.0353C13.2826 28.0353 16.8859 30.3356 19.4676 31.1279C24.9621 32.8141 28.6752 31.9525 34.1571 30.2259C38.1072 28.9818 43.5636 25.3294 43.5636 25.3294V22.7522H41.8885C41.8885 22.7522 42.0015 20.2279 41.4653 18.3924C40.768 16.0048 39.965 14.3661 38.0228 12.8303C36.8608 11.9114 29.1954 10.0233 23.8487 11.5418C19.0145 12.9147 15.2957 15.0901 14.1472 17.8557Z"
        fill="#6450F7"
      />
      <circle cx="32.4562" cy="26.337" r="12.548" fill="#3B3184" />
    </g>
    <mask
      id="mask1_12328_76611"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="6"
      y="27"
      width="29"
      height="12"
    >
      <path
        d="M13.3592 27.8623C13.3592 27.8623 16.5289 28.5376 18.5774 28.8723C24.7575 29.8818 34.5688 30.0506 34.5688 30.0506L25.2949 37.8288C24.6076 38.4052 23.6199 38.4554 22.8532 37.9897C20.7948 36.7396 16.6455 34.4687 13.3592 34.2589C11.4279 34.1355 8.99131 34.6727 7.07924 35.224C6.44898 35.4057 5.92072 34.5038 6.41 34.0669L13.3592 27.8623Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_12328_76611)">
      <path
        d="M13.3592 27.8623C13.3592 27.8623 16.5289 28.5376 18.5774 28.8723C24.7575 29.8818 34.5688 30.0506 34.5688 30.0506L24.8141 38.232C24.411 38.5701 23.8342 38.6012 23.389 38.3209C21.6053 37.1981 16.9633 34.489 13.3592 34.2589C11.4279 34.1355 8.99131 34.6727 7.07924 35.224C6.44898 35.4057 5.92072 34.5038 6.41 34.0669L13.3592 27.8623Z"
        fill="#3B3184"
      />
      <circle cx="10.3075" cy="20.3397" r="17.4452" fill="#6450F7" />
    </g>
    <path
      d="M18.662 17.1201L19.9849 21.1913L24.2655 21.1913L20.8024 23.7074L22.1252 27.7786L18.662 25.2625L15.8991 26.8848L16.9452 23.7074L14.0684 21.5235H17.599L18.662 17.1201Z"
      fill="url(#paint0_linear_12328_76611)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12328_76611"
        x1="16.8352"
        y1="21.5415"
        x2="24.2655"
        y2="24.4274"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" stopColor="white" />
        <stop offset="0.5" stopColor="#E6E6E6" />
      </linearGradient>
    </defs>
  </svg>
)
